export const triggerValidChange =
  ({ field, schema, onChange, currentValue }) =>
  async (value) => {
    if (currentValue === value) {
      return
    }
    const {
      fields: { [field]: fieldSchema },
    } = schema()
    const isValid = await fieldSchema.validate(value).then(
      () => true,
      () => false
    )

    if (isValid) {
      onChange(value)
    }
  }
